export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.81013b3e05554f15d47e81b7cda8daa2.css";